import { HttpErrorResponse } from '@angular/common/http';
import { Observable, ObservableInput } from 'rxjs';

export abstract class APIErrorHandler {
    abstract handleError<T>(err: HttpErrorResponse, caught?: Observable<T>): ObservableInput<any>;
}
